import { motion, AnimatePresence } from 'motion/react';
import { Scroll } from 'lucide-react';

type LogEntry = { id: number | string; text: string; color: string; timestamp?: number };

interface ActivityLogProps {
  logs: LogEntry[];
}

// Renders inside MorePanel's own white card (bg-white pixel-corners
// p-[18px]) — no chrome of its own, just the section label + rows, same
// language as PixelPass/LootBag/LoreArchive's always-on section labels.
export default function ActivityLog({ logs }: ActivityLogProps) {
  return (
    <div className="flex flex-col">
      <h2 className="font-heading text-[9px] tracking-[1px] uppercase text-body-grey mb-4 flex items-center gap-2">
        <Scroll size={14} /> Activity log
      </h2>
      <div className="flex-1 overflow-hidden flex flex-col gap-3">
        <AnimatePresence>
          {logs.slice(0, 5).map((log) => (
            <motion.div
              key={log.id}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0 }}
              className="leading-relaxed break-words"
            >
              <p className="font-grotesk font-medium text-[13px] text-primary">
                {log.text}
              </p>
              {log.timestamp && (
                <p className="font-grotesk text-[11px] text-body-grey mt-0.5">
                  {new Date(log.timestamp).toLocaleDateString('en-AU', { day: 'numeric', month: 'short' })}
                  {' '}
                  {new Date(log.timestamp).toLocaleTimeString('en-AU', { hour: '2-digit', minute: '2-digit' })}
                </p>
              )}
            </motion.div>
          ))}
        </AnimatePresence>
        {logs.length === 0 && (
          <p className="font-grotesk font-medium text-[13px] text-body-grey text-center py-4">No activity yet</p>
        )}
      </div>
    </div>
  );
}
